import * as React from 'react'
import { ButtonElement } from './styled'
export interface ButtonElementProps {
  flex?: boolean
  style?: React.CSSProperties
  margin?: string
  backgroundColor?: string
  autoFocus?: boolean
  color?: string
  activeColor?: string
  activeBacgroundColor?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const loseFocus = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
  const target = event.target as any
  target.blur()
}

interface ButtonProps extends ButtonElementProps {
  label?: string
}
export const Button: React.FC<ButtonProps> = ({ label, ...buttonProps }) => (
  <ButtonElement onMouseUp={loseFocus} {...buttonProps}>
    {label}
  </ButtonElement>
)
